import Moment from "moment";
import { VatService } from "../../classes/VatService";
/**
 * Gets the standard rate of VAT on an amount.
 *
 * @param amount
 * @param date
 */
export function getVatOn(amount, date = null) {
    date = date ? Moment(date) : Moment();
    let v = new VatService(date);
    return v.getVatOn(amount, 'S');
}
